export const colors = {
  alabaster: '#F8F8F8',
  astra: '#FCF0C0',
  athensGray: '#E6E9ED',
  black: '#000000',
  blackSqueeze: '#EAF5F7',
  bostonBlue: '#3DA3AF',
  brightGray: '#353B43',
  cadetBlue: '#AAB2BD',
  carnation: '#F6475E',
  catskillWhite: '#F5F7FA',
  ceriseRed: '#D23264',
  deepCerulean: '#00819E',
  denim: '#1A6FDA',
  error: '#C52A2A',
  flushOrange: '#FF8000',
  gallery: '#EAEAEA',
  ghost: '#CCD1D9',
  gray: '#929292',
  lima: '#7FC50F',
  limeade: '#64A301',
  mako: '#434A54',
  manatee: '#9198A2',
  mariner: '#2071D7',
  mineShaft: '#262626',
  monza: '#C5071B',
  nevada: '#656D78',
  paleGreen: '#EEF5F2',
  pizazz: '#FF8A00',
  radicalRed: '#FF3C54',
  redRibbon: '#E00034',
  royalBlue: '#4767F2',
  selectiveYellow: '#FCB200',
  swansDown: '#D6EBEF',
  thunder: '#2B2B2B',
  tundora: '#494949',
  warmGrey: '#929292',
  white: '#FFFFFF',
  whiteCloud: '#F8F8F8',
  framboise: '#D23264',
  darkerFramboise: '#6A1832',
  dustyGray: '#999999',
  easternBlue: '#15A8B2',
  fern: '#52B375',
  darkGrey: '#2B2B2B',
}
